import React, { PureComponent } from 'react'
import { Alert, Form, Icon, Input, Checkbox } from 'antd'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import { infoRequired } from '../../utils/validators'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import iconContato from '../../images/iconContato.png'
import iconInsta from '../../images/insta.svg'
import iconLinkedin from '../../images/linkedin.svg'
import iconYoutube from '../../images/youtube.svg'
import { Link } from 'react-router-dom'
import './contato.css'
import { request } from '../../utils/api';
import CookieConsentComponent from '../../Components/CookieConsent'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { connect } from 'react-redux'

const FormContato = Form.create({ name: 'contato-form' })(
    connect(mapStateToProps, mapDispatchToProps)(
        ({ form, handleSubmit, loading, message }) => (
                <Form layout="vertical" onSubmit={(e) => handleSubmit(e, form)}>
                    {message && (
                        <Form.Item>
                            <Alert message={message} type="error" showIcon />
                        </Form.Item>
                    )}

                    {loading && (
                        <Form.Item>
                            <div style={{ textAlign: 'center' }}>
                                <Icon type="loading" />
                            </div>
                        </Form.Item>
                    )}

                    <Form.Item label="Nome">
                        {form.getFieldDecorator('nome', {
                            rules: [ infoRequired ]
                        })(
                            <Input placeholder="Nome" style={{ width: '100%' }} />
                        )}
                    </Form.Item>
            
                    <Form.Item label="E-mail">
                        {form.getFieldDecorator('email', {
                            rules: [ infoRequired ]
                        })(
                            <Input placeholder="E-mail" style={{ width: '100%' }} />
                        )}
                    </Form.Item>
            
                    <Form.Item label="Assunto">
                        {form.getFieldDecorator('assunto', {
                            rules: [ infoRequired ]
                        })(
                            <Input placeholder="Assunto" style={{ width: '100%' }} />
                        )}
                    </Form.Item>
            
                    <Form.Item label="Mensagem">
                        {form.getFieldDecorator('mensagem', {
                            rules: [ infoRequired ]
                        })(
                            <Input.TextArea rows={6} placeholder="Mensagem" style={{ width: '100%' }} />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {form.getFieldDecorator('checkbox', {
                            rules: [ infoRequired ]
                        })(
                            <Checkbox className='text-white'>Li e concordo com a <a href="https://up365capital.com.br/politica.html" target="_blank" className="tx-pink">Política de Privacidade</a></Checkbox>
                        )}
                    </Form.Item>
            
                    <Form.Item>
                        <button type="submit">Enviar Mensagem</button>
                    </Form.Item>
                </Form>
        )
    )
)

class FormContatoRaw extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            message: '',
            success: false,
            fillBackground: false,
        }
    }
    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    handleSubmit = (e, form) => {
        // console.log(form)
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({ loading: true })
                window.scrollTo(0, 190)
                try {
                    const { code, message } = await request('sendMessage', 'POST', {
                        nome: values.nome,
                        email: values.email,
                        assunto: values.assunto,
                        mensagem: values.mensagem
                    })
                    if (code === 'A1') {
                        this.setState({
                            success: true,
                            loading: false,
                            message: ''
                        })
                    } else {
                        this.setState({
                            loading: false,
                            message: message || 'Erro ao enviar a mensagem'
                        })
                    }
                } catch(e) {
                    // console.log(e)
                    this.setState({
                        loading: false,
                        message: 'Ops! Algo deu errado!'
                    })
                }
            }
        })
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return(
        <div id="contatoSection">
        <Navbar fillBackground={this.state.fillBackground} />
            <div className="section contatoWrapper">
                <Container>
                    <Row>
                        <Col md={12}>
                            <h2 className="pageCall text-white w-100">Entre em contato conosco <br/>para <span className="tx-pink">tirar dúvidas</span> ou <span className="tx-pink"><br/>sugerir ideias</span>.</h2>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="section insideSec contatoSec">
                <Container>
                    <Row>
                        <Col md={6} id="contato">
                        {this.state.success ? (
                            <div style={{ padding: 25, border: '1px solid #eee', borderRadius: 4 }} className="animated bounceInRight">
                                <div className="senhaSuccess">
                                    <div>
                                        <Icon type="check-circle" className="text-white mb-5 display-4" />
                                    </div>
                                    <div>
                                        <h2 className="text-white">Mensagem enviada!</h2>
                                        <div className="text-white">Sua mensagem foi enviada com sucesso e entraremos em contato no período de até um dia útil. Obrigado!</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <FormContato handleSubmit={this.handleSubmit} loading={this.state.loading} message={this.state.message} />
                        )}
                        </Col>
                        <Col md={6}>
                            <div className="limiterContato">
                                <img alt="Ícone de contato" src={iconContato} className="img-fluid" />
                                <h4 className="limiterTitle text-white text-left">Siga o {process.env.REACT_APP_NAME}</h4>
                                <p className="text-white">Veja nossos conteúdos sobre finanças e o mundo da criptoeconomia!</p>
                                <div className="contatoIcons">
                                    <a rel="noopener noreferrer" href="https://www.instagram.com/somosflow.in/" target="_blank"> <img className="icon" src={iconInsta}/></a>
                                    <a rel="noopener noreferrer" href="https://www.youtube.com/channel/UCXQeCQhc5MjoFLsIYPEKAeg" target="_blank"><img className="icon" src={iconYoutube}/></a>
                                    <a rel="noopener noreferrer" href="https://www.linkedin.com/company/somosflowin/" target="_blank"><img className="icon" src={iconLinkedin}/></a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <CookieConsentComponent />
            <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(FormContatoRaw)


